<h2 class="pb-[2.5rem]">{{ 'portalQuestionnaire.title' | transloco }}</h2>

<div class="flex flex-col mb-20">
  <div
    class="flex justify-between md:mb-4 bg-vinciLavender md:bg-white rounded-t-xl md:rounded-3xl"
  >
    <div
      class="flex flex-col gap-[1.5rem] md:justify-between p-[1.5rem] md:p-[2.5rem]"
    >
      <h4 class="flex items-center gap-4">
        <icon [name]="'thunder'" [size]="'1.5625rem'"></icon> {{
        'portalQuestionnaire.questionnaireGoals' | transloco }}
      </h4>
      <p>
        <span>
          {{ 'portalQuestionnaire.questionnaireGoalsTextPart1' | transloco }}
        </span>
        <br />
        <span>
          {{ 'portalQuestionnaire.questionnaireGoalsTextPart2' | transloco }}
        </span>
      </p>
      <p>
        <span>
          {{ 'portalQuestionnaire.questionnaireGoalsMaturityScaleTextPart1' |
          transloco }}
        </span>
        <span class="!font-bold">
          {{ 'portalQuestionnaire.questionnaireGoalsMaturityScaleTextPart2' |
          transloco }}
        </span>
        <span>
          {{ 'portalQuestionnaire.questionnaireGoalsMaturityScaleTextPart3' |
          transloco }}
        </span>
        <span class="!font-bold">
          {{ 'portalQuestionnaire.questionnaireGoalsMaturityScaleTextPart4' |
          transloco }}
        </span>
        <span>
          {{ 'portalQuestionnaire.questionnaireGoalsMaturityScaleTextPart5' |
          transloco }}
        </span>
      </p>
      <ul class="list-disc pl-10">
        <li>
          <p>
            {{ 'portalQuestionnaire.questionnaireGoalsMaturityLevelZero' |
            transloco }}
          </p>
        </li>
        <li>
          <p>
            {{ 'portalQuestionnaire.questionnaireGoalsMaturityLevelOne' |
            transloco }}
          </p>
        </li>
        <li>
          <p>
            {{ 'portalQuestionnaire.questionnaireGoalsMaturityLevelTwo' |
            transloco }}
          </p>
        </li>
        <li>
          <p>
            {{ 'portalQuestionnaire.questionnaireGoalsMaturityLevelThree' |
            transloco }}
          </p>
        </li>
      </ul>
      <p>
        {{ 'portalQuestionnaire.questionnaireGoalsMaturityLevelText' | transloco
        }}
      </p>
      <ul class="list-disc pl-10">
        <li>
          <p>
            <span class="!font-bold">
              {{
              'portalQuestionnaire.questionnaireGoalsMaturityLevelImmaturePart1'
              | transloco }}
            </span>
            <span>
              {{
              'portalQuestionnaire.questionnaireGoalsMaturityLevelImmaturePart2'
              | transloco }}
            </span>
          </p>
        </li>
        <li>
          <p>
            <span class="!font-bold">
              {{
              'portalQuestionnaire.questionnaireGoalsMaturityLevelPartlyMaturePart1'
              | transloco }}
            </span>
            <span>
              {{
              'portalQuestionnaire.questionnaireGoalsMaturityLevelPartlyMaturePart2'
              | transloco }}
            </span>
          </p>
        </li>
        <li>
          <p>
            <span class="!font-bold">
              {{
              'portalQuestionnaire.questionnaireGoalsMaturityLevelMaturePart1' |
              transloco }}
            </span>
            <span>
              {{
              'portalQuestionnaire.questionnaireGoalsMaturityLevelMaturePart2' |
              transloco }}
            </span>
          </p>
        </li>
      </ul>
    </div>
    <div class="flex flex-none justify-end">
      <img
        src="assets/images/questionnaire/questionnaire-desktop.png"
        alt="questionnaire"
        class="mobile-hidden rounded-r-xl md:rounded-r-3xl object-none"
      />
    </div>
  </div>

  <div
    class="flex flex-col gap-[1.5rem] p-[1.5rem] md:p-[2.5rem] bg-white md:rounded-3xl rounded-b-3xl mb-4"
  >
    <div class="flex justify-between items-center">
      <h4 class="flex items-center gap-4">
        <icon [name]="'clock'" [size]="'1.5625rem'"></icon> {{
        'portalQuestionnaire.myQuestionnaire' | transloco }}
      </h4>
      @if(questionnaireState()===2){
      <span class="flex gap-2 items-center font-bold text-vinciRed"
        ><icon [name]="'danger'" [size]="'1.5rem'"></icon>
        {{ 'portalQuestionnaire.outdatedQuestionnaire' | transloco }}
      </span>
      }
    </div>

    <p>
      <span>
        {{ 'portalQuestionnaire.questionnaireDetailsTextPart1' | transloco }}
      </span>
      <span class="!font-bold">
        {{ 'portalQuestionnaire.questionnaireDetailsTextPart2' | transloco }}
      </span>
      <span>
        {{ 'portalQuestionnaire.questionnaireDetailsTextPart3' | transloco }}
      </span>
      <span class="!font-bold">
        {{ 'portalQuestionnaire.questionnaireDetailsTextPart4' | transloco }}
      </span>
      <span>
        {{ 'portalQuestionnaire.questionnaireDetailsTextPart5' | transloco }}
      </span>
      <span class="!font-bold">
        {{ 'portalQuestionnaire.questionnaireDetailsTextPart6' | transloco }}
      </span>
      <span>
        {{ 'portalQuestionnaire.questionnaireDetailsTextPart7' | transloco }}
      </span>
      <span class="!font-bold">
        {{ 'portalQuestionnaire.questionnaireDetailsTextPart8' | transloco }}
      </span>
      <span>
        {{ 'portalQuestionnaire.questionnaireDetailsTextPart9' | transloco }}
      </span>
      <span class="!font-bold">
        {{ 'portalQuestionnaire.questionnaireDetailsTextPart10' | transloco }}
      </span>
      <span>
        {{ 'portalQuestionnaire.questionnaireDetailsTextPart11' | transloco }}
      </span>
    </p>

    @if(isLoading()){
    <loader class="self-center" />
    } @else if (hasQuestionnaire() && !isNewMode()) {

    <div class="flex gap-2 items-center mobile-hidden">
      <icon [name]="'insights'" [size]="'40px'"></icon>
      <p class="text-vinciBlue">
        <span class="font-bold">
          {{ 'portalQuestionnaire.maturityLvl' | transloco }} {{
          questionnaireScore().score }} {{ "/" }} {{
          questionnaireScore().maxPossibleScore }}
        </span>
      </p>
      <div class="flex flex-row gap-4 ml-auto">
        @if (maturityLevel() === 'Low') {
        <p
          class="pl-3 pr-3 pt-1 pb-1 rounded-full border-1 border-vinciBrown text-vinciBrown bg-vinciBrown-100"
        >
          {{ 'portalQuestionnaire.notMature' | transloco }}
        </p>
        } @else if (maturityLevel() === 'Medium') {
        <p
          class="pl-3 pr-3 pt-1 pb-1 rounded-full border-1 border-vinciBlue text-vinciBlue bg-vinciBlue-150"
        >
          {{ 'portalQuestionnaire.almostMature' | transloco }}
        </p>
        } @else if (maturityLevel() === 'High') {
        <p
          class="pl-3 pr-3 pt-1 pb-1 rounded-full border-1 border-vinciGreen text-vinciGreen bg-vinciGreen-100"
        >
          {{ 'portalQuestionnaire.mature' | transloco }}
        </p>
        }
      </div>
    </div>
    <div class="flex flex-col gap-6 w-full desktop-hidden">
      <div class="flex flew-row gap-2 items-center">
        <icon [name]="'insights'" [size]="'40px'"></icon>
        <p class="text-vinciBlue">
          <span class="font-bold">
            {{ 'portalQuestionnaire.maturityLvl' | transloco }} {{
            questionnaireScore().score }} {{ "/" }} {{
            questionnaireScore().maxPossibleScore }}
          </span>
        </p>
      </div>
      @if (maturityLevel() === 'Low') {
      <p
        class="w-fit pl-3 pr-3 pt-1 pb-1 rounded-full border-1 border-vinciBrown text-vinciBrown bg-vinciBrown-100"
      >
        {{ 'portalQuestionnaire.notMature' | transloco }}
      </p>
      } @else if (maturityLevel() === 'Medium') {
      <p
        class="w-fit pl-3 pr-3 pt-1 pb-1 rounded-full border-1 border-vinciBlue text-vinciBlue bg-vinciBlue-150"
      >
        {{ 'portalQuestionnaire.almostMature' | transloco }}
      </p>
      } @else if (maturityLevel() === 'High') {
      <p
        class="w-fit pl-3 pr-3 pt-1 pb-1 rounded-full border-1 border-vinciGreen text-vinciGreen bg-vinciGreen-100"
      >
        {{ 'portalQuestionnaire.mature' | transloco }}
      </p>
      }
    </div>
    <div
      class="p-4 flex flex-col md:flex-row md:justify-between gap-2 rounded-lg border-2 border-vinciBlue-300"
    >
      <div
        class="flex flex-col md:flex-row md:items-center gap-1 md:gap-[0.875rem]"
      >
        <p class="flex gap-3 items-center">
          <icon [name]="'document'" [size]="'1.125rem'" class="mb-1"></icon>
          {{ questionnaireStore.questionnaire()!.createdAt | date:
          'longDate':undefined:currentLocale }}
        </p>
        <span class="text-vinciGrey-400 text-sm md:mt-[0.125rem]">
          {{ 'portalQuestionnaire.disappearThe' | transloco }} {{
          questionnaireStore.questionnaire()!.getExpirationDate() | date:
          'longDate':undefined:currentLocale }}
        </span>
      </div>

      <div class="flex flex-wrap flex-col md:flex-row items-center gap-[0.8125rem] md:self-center">
        <app-button
          [text]="'portalQuestionnaire.ctaDeleteText' | transloco"
          [variant]="'destructive'"
          [icon]="'trash'"
          [iconSize]="'1.125rem'"
          [iconPosition]="'left'"
          (buttonClick)="openDeleteModal()"
          class="md:self-center max-md:w-full"
        ></app-button>
        @if (isPrinting()) {
        <app-button
          [text]="'portalQuestionnaire.ctaDownloadText' | transloco"
          [variant]="'quaternary'"
          [icon]="'loader'"
          [iconSize]="'18px'"
          [iconPosition]="'left'"
          [disabled]="true"
          (buttonClick)="downloadQuestionnaire()"
        ></app-button>
        } @else {
        <app-button
          [text]="'portalQuestionnaire.ctaDownloadText' | transloco"
          [variant]="'quaternary'"
          [icon]="'arrow-down'"
          [iconSize]="'1.125rem'"
          [iconPosition]="'left'"
          (buttonClick)="downloadQuestionnaire()"
          class="max-md:w-full"
        ></app-button>
        } @if(questionnaireState()!=2){
        <app-button
          [text]="'portalQuestionnaire.ctaContinueText' | transloco"
          [variant]="'secondary'"
          [icon]="'pen'"
          [iconSize]="'1.125rem'"
          [iconPosition]="'left'"
          (buttonClick)="continueQuestionnaire()"
          class="md:self-center max-md:w-full"
        ></app-button>
        }
      </div>
    </div>
    } @else {
    <p class="text-vinciGrey-400 self-center">
      {{ 'portalQuestionnaire.noQuestionnaireYet' | transloco }}
    </p>
    }
  </div>

  @if (!isLoading()) {<app-button
    [text]="startButtonTextKey() | transloco"
    [variant]="'secondary'"
    [disabled]="isInitializing()"
    [icon]="'arrow-right'"
    (buttonClick)="startOrRestartQuestionnaire()"
    class="md:self-end"
  ></app-button
  >}
</div>

@if (isPrinting()) {
<div #printContainer class="fixed left-[-9999px] top-0" aria-hidden="true">
  <div class="flex flex-col gap-[40px]">
    @for(section of questionnaireStore.questionnaire()!.sections; track $index)
    { @if(section.questions && section.questions.length > 0) {
    <questionnaire-section
      [title]="section.title"
      [section]="section"
      [sectionIndex]="$index"
    ></questionnaire-section>
    } }
  </div>
</div>
} @if(isDeleteModalOpen()){
<app-modal
  [title]="'portalQuestionnaire.deleteModalTitle' | transloco"
  [text]="'portalQuestionnaire.deleteModalText' | transloco"
  [buttonText]="'portalQuestionnaire.deleteModalCtaText' | transloco"
  [type]="'secondary'"
  (closeModal)="closeDeleteModal()"
  (completeModal)="deleteQuestionnaire()"
></app-modal
>} @else if(isRestartModalOpen()){
<app-modal
  [title]="'portalQuestionnaire.deleteModalTitle' | transloco"
  [text]="'portalQuestionnaire.restartModalText' | transloco"
  [buttonText]="'portalQuestionnaire.deleteModalCtaText' | transloco"
  (closeModal)="closeRestartModal()"
  (completeModal)="startQuestionnaire()"
></app-modal>
}
